import BaseballResultsProcessor from '../entities/BaseballResultsProcessor.js';
import { filterOnlyPitches } from '../filters/byResultTypes.js';
import { filterOnlyHits, filterOnlyStrikeOuts, filterOnlyHomeRuns } from '../filters/byPitchResult.js';
import { filterOnlyHavingParameterSet } from '../filters/byParameterName.js';
import { ResultData, PitchReprocessed } from '../enums/index.js';

const calculateBatterStats = function(resultsProcessor, pitches, groupPitchesBy){
    let statsPerBatter = {};
    let pitchesPerBatter = resultsProcessor.groupData(pitches, [groupPitchesBy]);

    for (let batterTagId in pitchesPerBatter) {
        if (!pitchesPerBatter.hasOwnProperty(batterTagId)) {
            continue;
        }

        let statsForBatterTag = {
            PlateAppearances: 0,
            Hits: 0,
            StrikeOuts: 0,
            HomeRuns: 0
        };

        // get results
        try {
            let containingPa = resultsProcessor.filterData(
                pitchesPerBatter[batterTagId],
                filterOnlyHavingParameterSet(ResultData.getDataPath(PitchReprocessed.PlateAppearanceR.key))
            );

            if (typeof(containingPa) === 'object' && containingPa.length){
                for (let index = 0; index < containingPa.length; index++) {
                    const singleResult = containingPa[index];
                    const currentPa = resultsProcessor.getObjectContent(singleResult, ResultData.getDataPath(PitchReprocessed.PlateAppearanceR.key));

                    if (typeof(currentPa) === 'number' && currentPa > statsForBatterTag.PlateAppearances){
                        statsForBatterTag.PlateAppearances = currentPa;
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }

        try {
            let classifiedAsHits = resultsProcessor.filterData(pitchesPerBatter[batterTagId], filterOnlyHits())
            statsForBatterTag.Hits = classifiedAsHits.length;
        } catch (error) {
            // TODO - log ?
        }

        try {
            let classifiedAsStrikeOuts = resultsProcessor.filterData(pitchesPerBatter[batterTagId], filterOnlyStrikeOuts());
            statsForBatterTag.StrikeOuts = classifiedAsStrikeOuts.length;
        } catch (error) {
            // TODO - log ?
        }

        try {
            let classifiedAsHomeRuns = resultsProcessor.filterData(pitchesPerBatter[batterTagId], filterOnlyHomeRuns());
            statsForBatterTag.HomeRuns = classifiedAsHomeRuns.length;
        } catch (error) {
            // TODO - log ?
        }

        statsPerBatter[batterTagId] = statsForBatterTag;
    }

    return statsPerBatter;
};

const calculateStatsForPitchers = function(resultsProcessor, results, groupPitchesBy){
    let statsPerPitcher = {};
    let resultsPerGroupingKey = resultsProcessor.groupData(results, [groupPitchesBy]);

    for (let pitcherTagId in resultsPerGroupingKey) {
        if (!resultsPerGroupingKey.hasOwnProperty(pitcherTagId)) {
            continue;
        }

        let statsForPitcherTag = {
            NumberOfPitches: 0,
            Hits: 0,
            StrikeOuts: 0,
            HomeRuns: 0
        };

        // get results
        try {
            let classifiedAsHits = resultsProcessor.filterData(resultsPerGroupingKey[pitcherTagId], filterOnlyHits())
            statsForPitcherTag.Hits = classifiedAsHits.length;
        } catch (error) {
            // TODO - log ?
        }

        try {
            let classifiedAsStrikeOuts = resultsProcessor.filterData(resultsPerGroupingKey[pitcherTagId], filterOnlyStrikeOuts());
            statsForPitcherTag.StrikeOuts = classifiedAsStrikeOuts.length;
        } catch (error) {
            // TODO - log ?
        }

        try {
            let classifiedAsHomeRuns = resultsProcessor.filterData(resultsPerGroupingKey[pitcherTagId], filterOnlyHomeRuns());
            statsForPitcherTag.HomeRuns = classifiedAsHomeRuns.length;
        } catch (error) {
            // TODO - log ?
        }

        statsForPitcherTag.NumberOfPitches = resultsPerGroupingKey[pitcherTagId].length;
        statsPerPitcher[pitcherTagId] = statsForPitcherTag;
    }

    return statsPerPitcher;
};

const calculatePitchersStats = function(results, customResultsProcessor){
    let resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    let pitchesOnly =  resultsProcessor.filterData(results, filterOnlyPitches());
    let statsPerPitcher = calculateStatsForPitchers(resultsProcessor, pitchesOnly, ResultData.TagId.key);
    let uniquePitchers = resultsProcessor.getUniqueValues(pitchesOnly, [ResultData.TagId.key], false);

    let statsForPitchers = [];
    for(let i = 0; i < uniquePitchers.length; i++){
        const pitcherId = uniquePitchers[i];
        if (statsPerPitcher.hasOwnProperty(pitcherId)){
            statsForPitchers.push({ TagID: pitcherId, stats: statsPerPitcher[pitcherId]});
        }
    }

    return statsForPitchers;
};

const calculateBattersStats = function(results, customResultsProcessor){
    // stats from properly tagged pitches
    let resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    let pitchFilters = filterOnlyPitches();
    pitchFilters.push({ parameter: ResultData.BatterTagId.key, operator: '>', value: 0 });
    let pitchesOnly = resultsProcessor.filterData(results, pitchFilters);
    let taggedBattersStats = calculateBatterStats(resultsProcessor, pitchesOnly, ResultData.BatterTagId.key);

    // merge with hits which do not have associated pitches
    let uniqueBattersInOrder = resultsProcessor.getAllUniqueBatters(results, true);

    let statsForBatters = [];
    const noStats = {
        PlateAppearances: 0,
        Hits: 0,
        StrikeOuts: 0,
        HomeRuns: 0
    };

    // necessary to preserver order of hits prepended by pitches and not
    for (let i = 0; i < uniqueBattersInOrder.length; i++) {
        const batterId = uniqueBattersInOrder[i];
        if (batterId === 0){
            continue;
        }
        
        let statsForBatter = taggedBattersStats.hasOwnProperty(batterId) ?
            taggedBattersStats[batterId]: noStats;

        statsForBatters.push({ TagID: batterId, stats: statsForBatter});
    }

    return statsForBatters;
};

export {
    calculatePitchersStats, calculateBattersStats
};
